module.exports = __webpack_public_path__ + "img/avatar.68ce4951.png";